import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MyUploadAdapter } from 'src/app/generales/login/components/uploadImage';

@Component({
  selector: 'app-editer',
  templateUrl: './editer.component.html',
  styleUrls: ['./editer.component.scss'],
})
export class EditerComponent implements OnInit {
  @Input() longDescription = '';
  @Output() longDescriptionChange = new EventEmitter();

  public config = {
    removeButtons: 'Flash,Smiley,SpecialChar,PageBreak,Iframe,Link,Anchor,Unlink,Language,BidiRtl,BidiLtr,CreateDiv,Blockquote,Outdent,Indent,CopyFormatting,RemoveFormat,Maximize,ShowBlocks,About,Superscript,Subscript,Strike,HiddenField,ImageButton,Button,Select,Textarea,TextField,Radio,Checkbox,Form,Scayt,SelectAll,Find,Replace,Paste,PasteText,PasteFromWord,Copy,Templates,Save,NewPage,Preview,Print,Source,Cut',
    extraPlugins: 'justify,font'
  }

  constructor(
    private http: HttpClient
  ) { }

  ngOnInit() {}

  async uploadImg(ev){
    try{
      const upload = new MyUploadAdapter(this.http);
      const file = ev.target.files[0];
      const res: any = await upload.upload(file);
      if(res.status){
        this.longDescription += `<img src="${res.url}">`;
        // this.longDescriptionChange.emit(this.longDescription)
      }
      ev.target.value = null;
    }catch(err){
      console.error(err);
    }
  }

  change(ev){
    this.longDescription = ev;
    this.longDescriptionChange.emit(this.longDescription);
    // console.log(ev);
    // console.log(this.longDescription);
    // this.longDescriptionChange.emit(longDescription)
  }
}
